import { gql } from '@apollo/client';
import BaseService from './baseService';

class DispatchStatesService extends BaseService {
  constructor() {
    super();
    this.dispatchStatesGql = `
      stateId
      statusId
      status
      state
      order
    `;
  }

  getDispatchStates = () => new Promise((resolve, reject) => {
    const DISPATCH_STATES = gql`
      query {
        dispatchStates{
            ${this.dispatchStatesGql}
        }
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: DISPATCH_STATES
      })
      .then((result) => {
        if (result.data.dispatchStates) {
          resolve(result.data.dispatchStates);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}

const dispatchStatesService = new DispatchStatesService();

export default dispatchStatesService;
